import React from "react";
import { ARTIST, ALBUM, ASSETS, BG_TITLE } from "../data/worldData";

export default function EnterOverlay({ onEnter }) {
  return (
    <div
      data-testid="enter-overlay"
      className="fixed inset-0 z-[100] grain flex items-center justify-center"
      style={{ background: "var(--ink)" }}
    >
      <img src={ASSETS.cover} alt="" className="absolute inset-0 w-full h-full object-cover film opacity-40" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(21,16,14,0.55), rgba(21,16,14,0.85))" }} />

      <div className="relative z-10 text-center px-6 max-w-3xl">
        <h1 className="font-display font-extrabold text-[#ECE7DB] stretch-text leading-[0.82] text-6xl sm:text-8xl md:text-9xl animate-fade-up" style={{ animationDelay: "0.1s" }}>
          {ARTIST}
        </h1>
        <div className="flex items-center justify-center gap-4 my-7 animate-fade-up" style={{ animationDelay: "0.25s" }}>
          <span className="h-px w-12 bg-[#CF9026]" />
          <span className="font-tech text-[#CF9026] tracking-[0.3em] text-sm">{ALBUM}</span>
          <span className="h-px w-12 bg-[#CF9026]" />
        </div>
        <p className="font-body text-[#ECE7DB]/55 text-base md:text-lg mb-10 animate-fade-up" style={{ animationDelay: "0.4s" }}>
          Step inside the room — the record plays the moment you do.
        </p>
        <button
          data-testid="enter-world-button"
          onClick={onEnter}
          className="group font-tech tracking-[0.25em] text-sm text-[#15100E] bg-[#ECE7DB] px-12 py-4 hover:bg-[#CF9026] transition-colors duration-300 animate-fade-up edge"
          style={{ animationDelay: "0.55s" }}
        >
          ENTER &nbsp;→
        </button>
        <p className="font-tech text-[#ECE7DB]/35 text-[11px] mt-6 tracking-widest animate-fade-up" style={{ animationDelay: "0.7s" }}>
          ♪ SOUND ON · {BG_TITLE} LOOPS ON ENTRY
        </p>
      </div>
    </div>
  );
}
